import React, { useMemo } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Unauthorized from "../general/Unauthorized";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import Loading from "../general/Loading";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { useClientPagination } from "../reportes/useClientPagination";
import ReportPaginationFooter from "../reportes/ReportPaginationFooter";

function ListarEmpresas() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [permisos, setPermisos] = useState([]);
    let userdata = [];

    const [terminoBusqueda, setTerminoBusqueda] = useState('');

    const normalizarParaBusqueda = (texto) => {
        if (texto == null || texto === '') return '';
        return String(texto)
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    };

    const coincideTextoBusqueda = (texto, filtro) => {
        const termino = normalizarParaBusqueda(filtro);
        if (!termino) return true;
        const base = normalizarParaBusqueda(texto);
        if (base.includes(termino)) return true;
        const palabras = termino.split(' ').filter(Boolean);
        return palabras.every((palabra) => base.includes(palabra));
    };

    const cols = [
        { name: 'Empresa', selector: row => row.primer_nombre || 'N/A', sortable: true },
        { name: 'Tipo Documento', selector: row => row.tipo_documento || 'N/A', sortable: false, grow: 0.8 },
        { name: 'Nit', selector: row => {
            if (row.numero_documento && row.dv) {
                return `${row.numero_documento}-${row.dv}`;
            }
            return row.numero_documento || 'N/A';
        }, sortable: false, grow: 0.9 },
        { name: 'Email', selector: row => row.email || 'N/A', sortable: false },
        { name: 'Teléfono', selector: row => row.telefono || 'N/A', sortable: false, grow: 0.9 },
        { name: 'Acción', center: true, cell: row => getBotones(row), grow: 0.6 }
    ];

    const getBotones = (item) => {
        if (!permisos.includes('crearPacientes')) return null;
        return (
            <Link to={'/editar-empresa?id=' + item.id} className="btn btn-sm company-icon-btn" title="Editar empresa">
                <i className="far fa-edit"></i>
            </Link>
        );
    };

    const customTableStyles = useMemo(() => ({
        table: { style: { backgroundColor: '#fff' } },
        headRow: {
            style: {
                minHeight: '44px',
                borderBottom: '1px solid #e9eef3',
                backgroundColor: '#fafcfe'
            }
        },
        headCells: {
            style: {
                fontSize: '12px',
                fontWeight: 700,
                color: '#5f6b77',
                textTransform: 'uppercase',
                letterSpacing: '0.02em',
                paddingTop: '10px',
                paddingBottom: '10px'
            }
        },
        rows: {
            style: {
                minHeight: '52px',
                borderBottom: '1px solid #f1f4f8'
            }
        },
        cells: {
            style: {
                fontSize: '13px',
                color: '#2f3a45'
            }
        }
    }), []);

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));
        setPermisos(userdata.up || []);

        // 🔒 VALIDACIÓN DE PERMISOS - Usar el mismo permiso que listar pacientes
        let tienePermiso = false;

        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'crearPacientes');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('crearPacientes')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        console.log('🚀 ListarEmpresas - Iniciando carga de datos');

        // ✅ Cargar datos del cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                console.log('✅ Cliente cargado correctamente');
                if (response.status === 200) {
                    setUsername(userdata.user_name);
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('❌ Error cargando cliente:', error);
                setLoggedIn(true);
            });

        console.log('🔍 Intentando cargar empresas...');

        // ✅ Cargar empresas - Solo tipo_cliente = 1 (SIN filtro de profesional independiente)
        const parametrosFiltro = {
            uid: userdata.user_id
        };

        console.log('📤 Enviando petición a /empresas con parámetros:', parametrosFiltro);

        axios.get('/empresas', { params: parametrosFiltro })
            .then(response => {
                console.log('📥 Respuesta recibida del servidor:', response);
                if (response.status === 200) {
                    console.log('📊 Datos de empresas recibidos:', response.data);
                    setItems(response.data);
                } else {
                    console.log('⚠️ Status inesperado:', response.status);
                }
            })
            .catch(error => {
                console.error('❌ Error cargando empresas:', error);
                if (error.response) {
                    console.error('❌ Error response status:', error.response.status);
                    console.error('❌ Error response data:', error.response.data);
                }
            });
    }, []);

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            return;
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));

        const parametrosBusqueda = {
            uid: userdata.user_id,
            termino: terminoBusqueda
        };

        // ✅ Búsqueda de empresas
        axios.get('/empresas', { params: parametrosBusqueda })
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.error('❌ Error en búsqueda:', error);
            });

    }, [terminoBusqueda]);

    const itemsFiltrados = useMemo(() => {
        const termino = terminoBusqueda.trim();
        if (!termino) return items;
        return items.filter((item) => {
            const empresa = item.primer_nombre || '';
            const documento = `${item.numero_documento || ''}${item.dv ? '-' + item.dv : ''}`;
            const email = item.email || '';
            const telefono = item.telefono || '';
            return coincideTextoBusqueda(empresa, termino)
                || coincideTextoBusqueda(documento, termino)
                || coincideTextoBusqueda(email, termino)
                || coincideTextoBusqueda(telefono, termino);
        });
    }, [items, terminoBusqueda]);

    const pagination = useClientPagination(itemsFiltrados);

    // 🔒 PROTECCIÓN DE RUTA
    if (loggedIn && hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn && hasPermission) {
        return (
            <div className="hold-transition company-list-page">
                <Header client={client} />
                <Aside client={client} activelink="patients" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/menu-pacientes">Clientes</Link></li>
                                        <li className="breadcrumb-item" key="bc3">Listar Empresas</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Empresas</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="company-filters-box">
                                        <div className="row company-filters-row">
                                            <div className="col-lg-9 col-md-8">
                                                <div className="form-group company-filter-group">
                                                    <label htmlFor="terminoBusqueda">Buscar empresa</label>
                                                    <input 
                                                        type="text" 
                                                        name="terminoBusqueda" 
                                                        className="form-control" 
                                                        id="terminoBusqueda" 
                                                        placeholder="Nombre, NIT o email..."
                                                        onChange={(e) => setTerminoBusqueda(e.target.value)} 
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-4 company-create-col">
                                                <div className="form-group w-100 company-filter-group">
                                                    <label className="company-create-label-placeholder">Acción</label>
                                                    {permisos.includes('crearPacientes') &&
                                                        <Link to={'/crear-empresa'} className={'btn btn-success btn-block company-create-btn'}>
                                                            Crear Empresa
                                                        </Link>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-12" style={{ boxShadow: '0 0 14px rgba(0,0,0,0.09)', backgroundColor: 'white' }}>
                                    <DataTable
                                        columns={cols}
                                        data={pagination.paginatedItems}
                                        customStyles={customTableStyles}
                                        noDataComponent="No hay empresas registradas"
                                        id={'tabla-empresas'}
                                    />

                                    <ReportPaginationFooter
                                        totalRegistros={pagination.totalRegistros}
                                        indicePrimerRegistro={pagination.indicePrimerRegistro}
                                        indiceUltimoRegistro={pagination.indiceUltimoRegistro}
                                        paginaActual={pagination.paginaActual}
                                        cambiarPagina={pagination.cambiarPagina}
                                        totalPaginas={pagination.totalPaginas}
                                        registrosPorPagina={pagination.registrosPorPagina}
                                        onPageSizeChange={pagination.handlePageSizeChange}
                                        itemLabel="empresas"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <Footer showToast={false} delay={0} />
                <style>{`
                    .company-list-page .company-filters-box {
                        background: #fff;
                        border: 1px solid #e8edf2;
                        border-radius: 12px;
                        padding: 12px 12px 10px;
                        margin-bottom: 10px;
                        box-shadow: 0 4px 12px rgba(29, 45, 61, 0.04);
                    }
                    .company-list-page .company-filters-row {
                        display: flex;
                        align-items: flex-end;
                    }
                    .company-list-page .company-filter-group {
                        margin-bottom: 0;
                    }
                    .company-list-page .company-filter-group label {
                        min-height: 22px;
                        display: inline-flex;
                        align-items: flex-end;
                        margin-bottom: 0.45rem;
                    }
                    .company-list-page .company-create-col {
                        display: flex;
                        align-items: flex-end;
                    }
                    .company-list-page .company-create-col .company-filter-group {
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-end;
                        height: 100%;
                        padding-bottom: 0;
                    }
                    .company-list-page .company-create-btn {
                        border-radius: 10px;
                        font-weight: 700;
                        min-height: 38px;
                    }
                    .company-list-page .company-create-label-placeholder {
                        visibility: hidden;
                        display: block;
                        margin-bottom: 0.5rem;
                        font-size: 0.86rem;
                        line-height: 1.4;
                    }
                    .company-list-page .company-icon-btn {
                        border: 1px solid rgba(50, 58, 69, 0.18);
                        border-radius: 10px;
                        width: 31px;
                        height: 31px;
                        padding: 0;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(50, 58, 69, 0.1);
                        color: #2f3945;
                    }
                    .company-list-page .company-icon-btn:hover {
                        background: rgba(50, 58, 69, 0.16);
                    }
                `}</style>
            </div>
        );
    }

    return (
        <Loading />
    );
}

export default ListarEmpresas;